<template>
  <queryMetaConfig ref="formDesign" :dbTables="dbTableData"></queryMetaConfig>
</template>
<script>
import queryMetaConfig from "./components/formDesign/_src/formDesign.vue";
import api from "./api";
export default {
  name: "form",
  props: {
    config: {
      Type: Object,
      default: {
        schemeCode: "test",
        targetType: "view",
      },
    },
    customItems: {
      Type: Array,
      default: () => [],
    },
    // 设计编码
  },
  components: {
    queryMetaConfig,
  },

  data() {
    return {
      tableColumns: [],
      dbTableData: [],
      dbTableRData: [],
      formData: {
        Query_Scheme_Id: null,
        //创建人Id
        creator_user_id: null,
        //分类
        category: "",
        schemeCode: this.config.schemeCode,
        // 停用/启用
        enabledMark: 1,
        // 查询目标类型
        targetType: 0,
        // 备注
        description: "",
        f_FormType: 0,
      },
    };
  },
  methods: {
    validate() {
      return this.$refs.formDesign.validate();
    },
    getForm() {
      const db = [];
      const rdb = [];
      let primaryKey = []; // 调整支持多主键 2022/11/30

      if (this.formData.f_FormType != 1) {
        // 普通表单
        const mainTable = this.dbTableData.find((t) => t.type == "main");

        // 调整支持多主键 2022/11/30
        mainTable.columns.forEach((column) => {
          if (column.isPrimary) {
            primaryKey.push(column.name);
          }
        });
      }

      const dbTableData = this.$deepClone(this.dbTableData);

      const dbTableRData = this.$deepClone(this.dbTableRData);

      for (const item of dbTableData) {
        if (this.formData.f_FormType != 1) {
          delete item.columns;
        }

        db.push(item);
      }

      for (const item of dbTableRData) {
        if (this.formData.f_FormType != 1) {
          delete item.columns;
        }
        rdb.push(item);
      }

      let scheme = {
        dbCode: this.formData.f_DbCode,
        db: db,
        rdb: rdb,
        primaryKey: String(primaryKey),
        formInfo: this.$refs.formDesign.getData(),
        formType: this.formData.f_FormType,
      };
      this.formData.scheme = JSON.stringify(scheme);
      return this.$deepClone(this.formData);
    },

    async setForm(schemeCode) {
      let res = await api.get(`/queryScheme/${schemeCode}`);
      const data = res.data.data;
      if (data) {
        this.formData = res.data.data;

        let scheme = JSON.parse(data.scheme);

        // data.info.f_DbCode = scheme.dbCode;
        this.formData = data;

        this.dbTableData = scheme.db;

        this.dbTableRData = scheme.rdb || [];

        this.$refs.formDesign.setData(scheme.formInfo);
      } else {
        this.$refs.formDesign.setData({
          tabList: [
            {
              components: this.customItems,
              text: "主表信息",
            },
          ],
          historyType: "0",
        });
      }
      let obj = {
        id: "table",
        name: "table",
        comment: "表",
        type: "main",
        _isHover: false,
      };

      // 加载表数据

      obj.columns = this.config.columns
        .filter((item) => !item.isNotCus)
        .map((t) => ({
          name: t.prop, // 使用 prop 字段作为数据库列名
          csType: "string", // 原始数据没有提供此信息，这里假设为 string 类型
          isIdentity: false, // 原始数据没有提供此信息
          isPrimary: false, // 原始数据没有提供此信息
          isNullable: true, // 原始数据没有提供此信息，这里默认为可空
          coment: t.label, // 使用 label 字段作为描述
        }));

      console.log([obj]);

      this.dbTableData = [obj];
    },
  },
  async mounted() {
    this.setForm(this.config.schemeCode);
  },
};
</script>
